var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerraform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.517 332.526L481.42 251.826V90.1693L341.517 171.04V332.526Z",
    fill: "#4040B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.258 90.1693L326.161 171.04V332.526L186.258 251.74V90.1693ZM31 161.571L170.903 242.357V80.7855L31 0V161.571ZM186.258 431.055L326.161 511.841V350.27L186.258 269.484",
    fill: "#5C4EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraform);
export default __webpack_public_path__ + "static/media/terraform.8a57e0b14cc1508e7368bb35179da691.svg";
export { ForwardRef as ReactComponent };